import { ReactNode, useCallback, useRef } from "react";

import {
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
  ListItemSecondaryAction,
} from "@material-ui/core";
import BackupIcon from "@material-ui/icons/Backup";

import useAttachmentsPickerStyle from "./attachments_list_with_title.style";

import { BucketAttachment } from "../../../graphql/models";
import { useUploadAttachment } from "../../../hooks";
import { WithI18n } from "../../../i18n";
import { AttachmentsListWithTitleItem } from "./attachments_list_with_title_item";

export interface AttachmentWithTitleItem extends WithI18n<"title"> {
  file: BucketAttachment;
}

export interface AttachmentsListWithTitleProps {
  title?: ReactNode;
  items: AttachmentWithTitleItem[];
  disabled?: boolean;
  onUpdated: (attachments: AttachmentWithTitleItem[]) => void;
}

export function AttachmentsListWithTitle(props: AttachmentsListWithTitleProps) {
  const { items, disabled, onUpdated, title } = props;
  const classes = useAttachmentsPickerStyle();

  const triggerDeleteItem = (itemIndex: number) => {
    console.log("triggerDeleteItem()");
    const defaultValueCopy = [...(items ?? [])];
    defaultValueCopy.splice(itemIndex, 1);

    onUpdated([...defaultValueCopy]);
  };

  const triggerChangeItem = (
    itemIndex: number,
    item: AttachmentWithTitleItem
  ) => {
    console.log(`triggerChangeItem(), item is ${JSON.stringify(item)}`);
    const newItems = [...items];
    newItems.splice(itemIndex, 1, item);
    console.log(`onUpdated arg is ${JSON.stringify(newItems)}`);
    props.onUpdated(newItems);
  };

  const processUpload = useCallback(
    (attachment: { id: string; name?: string }) => {
      const url = computeAttachmentUrl(attachment.id);
      const name = attachment.name || url;
      onUpdated([
        ...(items ?? []),
        {
          i18n: {},
          file: {
            url,
            name,
          },
        },
      ]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const { uploadAttachment, computeAttachmentUrl } =
    useUploadAttachment(processUpload);

  const uploadFileRef = useRef(null);

  const onFilePickerChange = ({
    target: {
      validity,
      files: [file],
    },
  }: any) => {
    if (validity.valid) {
      const { name } = file;
      file.filename = name;
      uploadAttachment(file);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {title ?? (
          <Typography variant="h3" className={classes.title}>
            Gestione degli allegati
          </Typography>
        )}
        <List dense={false} style={{ width: "100%" }}>
          {items?.map((v, i) => (
            <AttachmentsListWithTitleItem
              key={v.file.url}
              item={v}
              onChange={(item) => triggerChangeItem(i, item)}
              onDeletingItem={() => triggerDeleteItem(i)}
            ></AttachmentsListWithTitleItem>
          ))}
          {!disabled && (
            <ListItem>
              <ListItemText primary={"Aggiungi un allegato"} />
              <ListItemSecondaryAction>
                <input
                  hidden
                  required
                  disabled={disabled}
                  ref={uploadFileRef}
                  id="upload-file"
                  type="file"
                  onChange={onFilePickerChange}
                />
                <IconButton
                  disabled={disabled}
                  onClick={() =>
                    uploadFileRef.current &&
                    (uploadFileRef.current as any).click()
                  }
                  edge="end"
                  aria-label="upload"
                >
                  <BackupIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          )}
        </List>
      </Grid>
    </Grid>
  );
}
